import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

export function button5_click(event) {
		$w('#text1').show();
}

export function button6_click(event) {
		$w('#text2').show();
}

export function button7_click(event) {
		$w('#text3').show();
}

export function image11_mouseIn(event) {
		$w('#image12').show();
}



export function image12_mouseOut(event) {
		$w('#image12').hide();
}

export function image10_mouseIn(event) {
		$w('#image13').show();
}

export function image13_mouseOut(event) {
		$w('#image13').hide();
}

export function image8_mouseIn(event) {
		$w('#image14').show();
}

export function image14_mouseOut(event) {
		$w('#image14').hide();
}

export function vectorImage1_mouseIn(event) {
		$w('#vectorImage2').show();
}

export function vectorImage2_mouseOut(event) {
		$w('#vectorImage2').hide();
}